import React, { ReactNode } from 'react'
import { AppSvg, newIcons } from '@web/walter-ui-kit'

import cn from 'classnames'
import styles from './style.module.css'
import useCopy from '~hooks/useCopy'
import { compactString } from '~utils/string'

export type ElementText = {
    type: 'element'
    content: ReactNode
}

export type StringText = {
    type: 'text'
    text?: string
    clampText?: boolean
    leftLength?: number
    rightLength?: number
}

export type CopyTextProps = (ElementText | StringText) & {
    copyText?: string
    mode?: 'primary' | 'secondary' | 'tertiary'
    dataPointer?: string
    size?: 's' | 'm'
    className?: string
}

// eslint-disable-next-line complexity
function CopyText(props: CopyTextProps) {
    const copy = useCopy()

    const { mode = 'primary', size = 'm', className } = props

    let content: ReactNode = null

    if (props.type === 'text') {
        let newText: string

        if (!props.clampText) {
            newText = props.text || props.copyText || ''
        } else {
            newText = compactString(props.text || props.copyText || '', {
                leftLength: props?.leftLength,
                rightLength: props?.rightLength,
            })
        }

        content = (
            <span
                data-pointer="content"
                className={cn(styles.copyText, { [styles.textTertiary]: mode === 'tertiary' })}
            >
                {newText}
            </span>
        )
    } else if (props.type === 'element') {
        content = props.content
    }

    return (
        <div
            className={cn(styles.copy, styles[size], !!props.copyText && 'cursor-pointer', className)}
            data-value={props.copyText}
            data-pointer={props.dataPointer}
            onClick={() => !!props.copyText && copy(props.copyText)}
        >
            {content}
            {props.copyText && (
                <div
                    className={cn(styles.copyIcon, {
                        [styles.primary]: mode === 'primary',
                        [styles.secondary]: mode === 'secondary',
                        [styles.tertiary]: mode === 'tertiary',
                    })}
                >
                    <AppSvg path="new-icons" svgName={newIcons.ic16Copy} size={16} />
                </div>
            )}
        </div>
    )
}

export default CopyText
